import * as React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";

const StyledPageHeader = styled(Box)(({ theme, gradient }) => ({
  backgroundColor: gradient === "true" ? "#fff" : "transparent",
  background:
    gradient === "true"
      ? `linear-gradient(180deg, #fff 94%, rgba(210,210,210,1) 100%)`
      : "transparent",
  gap: "1rem",
  margin: "0",
  padding: theme.spacing(3),
  position: "relative",
  alignItems: "flex-start",
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(3, 2),
  },
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2, 1),
  },
}));

const PageTitle = styled(Typography)(({ theme }) => ({
  display: "block",
  fontFamily: theme.typography.interFontStack,
  fontSize: theme.typography.h3.fontSize,
  lineHeight: "38px",
  fontWeight: 700,
  minWidth: "fit-content",
  color: "#02324E",
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.h6.fontSize,
    marginBottom: theme.spacing(1),
  },
}));

/* The title renders <h1> by default. Pages already under an <h1>, or rendering
 * several of these, should pass titleComponent="h2". */
export default function DashboardPageHeader({
  gradient,
  pageTitle,
  titleComponent = "h1",
  titleProps = {},
  children,
  ...args
}) {
  const title = pageTitle ? pageTitle : "DashboardPageHeader";
  return (
    <StyledPageHeader
      className="DashboardPageHeader"
      gradient={gradient}
      {...args}
    >
      <PageTitle component={titleComponent} {...titleProps}>
        {title}
      </PageTitle>
      {children}
    </StyledPageHeader>
  );
}

DashboardPageHeader.propTypes = {
  gradient: PropTypes.oneOf(["true", "false"]),
  pageTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  titleComponent: PropTypes.elementType,
  titleProps: PropTypes.object,
  children: PropTypes.node,
};
